import HistoryService from '../../../services/history';
import getAttributesParam from '../lib/get-attributes-param';
import { trackEvent } from '../../../lib/tracking';
import { DECORATION_BLOCKED, DECORATION_SELECTED } from './types';
import { runSchedulerTask } from '../../../utils/validators';
import getURLSearchParamsWithOthers from '../../../utils/getURLSearchParamsWithOthers';

const namespace = 'ui-pdp-variations';

const showError = picker => !!picker.error_message && !picker.error_message.is_deferred;

const handleOnSelectVariation = (
  product,
  selectedQuantity,
  selectedAttributes,
  pickerId,
  hasDeferredErrors,
  onSelectVariation,
  platform,
  setIsLoading,
) => {
  const permalink = product?.permalink?.toString();
  const params = permalink && new URLSearchParams(permalink.substring(permalink.indexOf('?')));
  const queryParamsPermalink = params ? Object.fromEntries(params.entries()) : {};
  const showed_trade_in = params && params.get('showed_trade_in');

  if (product.decoration_type !== DECORATION_SELECTED && product.decoration_type !== DECORATION_BLOCKED) {
    const attributesToReset = product.attributes || [];
    const newParams = getURLSearchParamsWithOthers({ ...queryParamsPermalink }, ['variation']);

    if (selectedAttributes) {
      attributesToReset.forEach(attribute => {
        if (selectedAttributes[attribute]) {
          delete selectedAttributes[attribute];
        }
      });
    }
    onSelectVariation(
      product.id,
      {
        ...newParams,
        attributes: getAttributesParam(selectedAttributes, pickerId, product.attribute_id),
        quantity: selectedQuantity,
        has_deferred_errors: hasDeferredErrors,
        platform,
        showed_trade_in,
      },
      setIsLoading,
    );
    runSchedulerTask(() => {
      trackEvent(product.track);
      HistoryService.replaceProductAndParam(
        product.permalink,
        { productId: product.id },
        {
          ...newParams,
          quantity: selectedQuantity,
        },
      );
    }, 'background');
  }
};

export { showError, handleOnSelectVariation, namespace };
